// extracted by mini-css-extract-plugin
var _1 = "tooltip_body";
var _2 = "tooltip_head";
var _3 = "tooltip_label";
var _4 = "tooltip_tooltip";
var _5 = "tooltip_topBar";
var _6 = "tooltip_wrapper";
export { _1 as "body", _2 as "head", _3 as "label", _4 as "tooltip", _5 as "topBar", _6 as "wrapper" }
